export default __webpack_public_path__ + "static/media/trashIcon.8944392c.svg";